export default __webpack_public_path__ + "static/media/59.e6b951f6.png";